import React from 'react';
import { Typography } from 'fronton-react';
import { ButtonProps, ButtonWithGAClickButton, Section } from 'common/components';
import { createElementKey } from 'utils';
import {
  stageCard,
  stageCardLabel,
  stageCardTitleWrapper,
  stageCardsContainer,
  stageCardsTitle,
} from './stage-cards-styles';

type StagesProps = {
  elementBlock: string;
  title: string;
  cards: {
    title: string;
    text: string;
    label: string;
    btn?: ButtonProps;
  }[];
};

export const StageCards: React.FC<StagesProps> = ({ elementBlock, cards, title }) => (
  <Section>
    <Typography className={stageCardsTitle} variant="h2" size="extra">{title}</Typography>
    
    <div className={stageCardsContainer}>
      {cards.map((stage, index) => (
        <div className={stageCard} key={createElementKey('stage', index)}>
          <div>
            <div className={stageCardTitleWrapper}>
              <Typography variant="m" size="overline">{stage.title}</Typography>
              {stage.label && <Typography className={stageCardLabel} variant="m" size="overline">{stage.label}</Typography>}
            </div>
            <Typography variant="m" size="body_long">{stage.text}</Typography>
          </div>
          {stage.btn && (
            <ButtonWithGAClickButton
              adaptive={false}
              elementBlock={elementBlock}
              elementName={stage.title}
              elementText={stage.btn.label ?? ''}
              {...(stage.btn.href ?
                { href: stage.btn.href, title: stage.btn.title }
                : {}
              )}
              fullWidth
              size="m"
              variant={stage.btn.variant ?? 'accent'}
            >
              {stage.btn.label}
            </ButtonWithGAClickButton>
          )}
        </div>
      ))}
    </div>
  </Section>
);
